
// annoucmenet bar height 
  function setAnnouncementBarHeight() {
    const announcementBar = document.querySelector('.announcement-bar');

    if (announcementBar) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        announcementBar.offsetHeight + 'px'
      );
    }
  }

  document.addEventListener('DOMContentLoaded', setAnnouncementBarHeight);
  window.addEventListener('resize', setAnnouncementBarHeight);


// TM FONT SIZE FOR THE PRODUCT TITLE
function wrapProductTrademark() {
  document.querySelectorAll(
    '.pdp-title h1, .featured-coll .product-title p, .main-collection-grid .product-title p, .eu-ritual-title, .cart-recommendation__title, .cart-items__title'
  ).forEach(function (title) {

    // Prevent wrapping the same ™ more than once
    if (title.querySelector('.product-trademark')) return;

    title.innerHTML = title.innerHTML.replace(
      /™/g,
      '<span class="product-trademark">™</span>'
    );
  });
}

document.addEventListener('DOMContentLoaded', function () {
  wrapProductTrademark();
});

// Handle dynamically rendered cart recommendations
document.addEventListener('cart:updated', function () {
  wrapProductTrademark();
});






/* Product page image layout related script starts here */

function init(component) {
  if (component.dataset.fitInit) return;
  component.dataset.fitInit = '1';
  const grid = component.closest('.product-information__grid');
  if (!grid) return;
  const scroller = component.querySelector('slideshow-slides');
  const getSlides = () => [...component.querySelectorAll('slideshow-slide[ref="slides[]"]')];

  // Snap the scroller exactly onto the active slide, with no animation or snapping interference
  const realign = () => {
    if (!scroller) return;
    const slides = getSlides();
    const active = slides.find(s => s.getAttribute('aria-hidden') === 'false') || slides[0];
    if (!active) return;

    const prevBehavior = scroller.style.scrollBehavior;
    const prevSnap = scroller.style.scrollSnapType;
    scroller.style.scrollBehavior = 'auto';
    scroller.style.scrollSnapType = 'none';

    const diff = active.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
    if (Math.abs(diff) > 1) scroller.scrollLeft += diff;

    requestAnimationFrame(() => {
      scroller.style.scrollBehavior = prevBehavior;
      scroller.style.scrollSnapType = prevSnap;
    });
  };

  const update = () => {
    if (!MQ.matches) {
      grid.style.removeProperty('--active-ratio');
      grid.style.removeProperty('--thumbs-w');
      requestAnimationFrame(realign); // re-align below the breakpoint too
      return;
    }
    const slides = getSlides();
    const active = slides.find(s => s.getAttribute('aria-hidden') === 'false') || slides[0];
    if (!active) return;

    grid.style.setProperty('--active-ratio', ratioOf(active).toFixed(4));

    const thumbs = component.querySelector('slideshow-controls[thumbnails]');
    const gap = parseFloat(getComputedStyle(component).columnGap) || 0;
    const tw = thumbs && thumbs.offsetWidth ? thumbs.offsetWidth + gap : 0;
    grid.style.setProperty('--thumbs-w', tw + 'px');

    // wait two frames so layout has settled before aligning
    requestAnimationFrame(() => requestAnimationFrame(realign));
  };

  // Debounce resize so we align once after the user stops dragging
  let resizeTimer;
  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(update, 120);
  };

  new MutationObserver(update).observe(component, {
    subtree: true, attributes: true, attributeFilter: ['aria-hidden']
  });
  component.addEventListener('loadedmetadata', update, true);
  component.addEventListener('load', update, true);
  MQ.addEventListener('change', update);
  window.addEventListener('resize', onResize);
  update();

  
}



/* ==========================================================
   Sticky media: only when the content column is taller
   (separate block, independent from the code above)
   ========================================================== */
(() => {
  const STICKY_MQ = window.matchMedia('(min-width: 750px)');

  function setupSticky() {
    const media = document.querySelector('.product-information__media');
    const details = document.querySelector('.product-information__grid .product-details');
    if (!media || !details || media.dataset.stickyInit) return;
    media.dataset.stickyInit = '1';

    const check = () => {
      const needsSticky = STICKY_MQ.matches && details.offsetHeight > media.offsetHeight + 40;
      media.classList.toggle('is-sticky-media', needsSticky);
    };

    new ResizeObserver(check).observe(details);
    new ResizeObserver(check).observe(media);
    STICKY_MQ.addEventListener('change', check);
    window.addEventListener('load', check);
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupSticky);
  else setupSticky();
})();